<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vs-table
      id="tbl2"
      ref="tbl2"
      stripe
      @selected="selected"
      :data="transactions2"
      class="table-dark-inverted responsable-table"
    >
      <template slot="thead">
        <!-- <th>{{'Amount' | localize}}</th>
      <th>{{'TraceNumber' | localize}}</th>
      <th>{{'TrackingNumber' | localize}}</th>
      <th>{{'State' | localize}}</th>
      <th>{{'PaymentGateway' | localize}}</th>
      <th>{{'PaymentType' | localize}}</th>
      <th>{{'PaymentDateTime' | localize}}</th>
      <th>{{'Source' | localize}}</th>
      <th *ngIf="showDestination">{{'Destination' | localize}}</th>
      <th>{{'SourceMobile' | localize}}</th>
      <th *ngIf="showDestination">{{'DestinationMobil' | localize}}</th>
        <th></th>-->

        <vs-th>نوع پرداخت</vs-th>
        <vs-th>مبلغ</vs-th>
        <!-- <vs-th>شماره پیگیری بانک</vs-th>
        <vs-th>شماره پیگیری 20پی</vs-th>-->
        <vs-th>درگاه پرداخت</vs-th>
        <vs-th>تاریخ پرداخت</vs-th>
        <vs-th>پرداخت کننده</vs-th>
        <vs-th>دریافت کننده</vs-th>
        <vs-th v-if="false">پذیرنده</vs-th>
        <vs-th sort-key="state" key="state">وضعیت</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="hide-title one-line">
            <feather-icon
              v-if="PaymentType[tr.transaction.paymentType]"
              :title="PaymentType[tr.transaction.paymentType].title"
              :icon="PaymentType[tr.transaction.paymentType].icon"
              svgClasses="h-6 w-6"
            ></feather-icon>
            <span v-if="PaymentType[tr.transaction.paymentType]">{{
              PaymentType[tr.transaction.paymentType].title
            }}</span>
          </vs-td>
          <vs-td>
            <span>{{
              parseInt(
                tr.transaction.amount - tr.transaction.commissionFromConsumer
              ).toLocaleString() + (tr.destinationUserId == uid ? "+" : "-")
            }}</span>
          </vs-td>
          <!-- <vs-td>
          <span>{{tr.transaction.traceNumber}}</span>
        </vs-td>
        <vs-td>
          <span>{{tr.transaction.trackingNumber}}</span>
          </vs-td>-->
          <vs-td class="e-col">
            <span>{{ PaymentGateway[tr.transaction.paymentGateway] }}</span>
          </vs-td>
          <vs-td>
            <span>{{
             $moment(tr.transaction.paymentDateTime).format(
                "HH:mm:ss - jYYYY/jMM/jDD"
              )
            }}</span>
          </vs-td>
          <vs-td :class="{ 'e-col': tr.sourceUserId == uid }">
            <span
              :style="tr.sourceUserId == uid ? 'opacity:0.5;' : ''"
              :title="tr.sourceMobile"
              >{{
                tr.sourceName +
                (tr.sourceUserId == uid ? "" : "(" + tr.sourceMobile + ")")
              }}</span
            >
          </vs-td>
          <vs-td :class="{ 'e-col': tr.destinationUserId == uid }">
            <span :style="tr.destinationUserId == uid ? 'opacity:0.5;' : ''">{{
              tr.destinationName
            }}</span>
          </vs-td>
          <vs-td v-if="false">
            <span>{{ tr.Destination }}</span>
          </vs-td>
          <vs-td class="d-only">
            <feather-icon
              :title="TransactionState[tr.transaction.state].title"
              :icon="TransactionState[tr.transaction.state].icon"
              :svgClasses="[
                `h-6 w-6 stroke-current text-${
                  TransactionState[tr.transaction.state].color
                }`,
              ]"
            ></feather-icon>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <transaction-details ref="TransactionDetails1"></transaction-details>
  </div>
</template>
<style>
</style>
<script>
import { PaymentGateway, PaymentType, TransactionState } from "@/enums.js";
import trans from "../../../http/requests/transactions.js";
import TransactionDetails from "../transaction/TransactionDetails.vue";
export default {
  props: {
    OnlyConsumer: { type: Boolean, default: false },
  },
  components: {
    TransactionDetails,
  },
  data() {
    return {
      transactions2: [],
      PaymentGateway,
      PaymentType,
      TransactionState,
    };
  },
  computed: {
    uid() {
      try {
        return this.$store.state.AppActiveUser.uid;
      } catch (e) {
        return "";
      }
    },
  },
  methods: {
    fillTable() {
      this.$vs.loading();
      let payload = {
        params: {
          OnlySource: this.OnlyConsumer,
          State: 1,
          Sorting: "transaction.paymentDateTime DESC",
          MaxResultCount: 10,
        },
      };
      trans
        .getUserTransactions(payload)
        .then((response) => {
          this.transactions2 = response.data.result.data.items;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http

      // this.$http
      //   .get("api/services/app/Transactions/GetAll", payload)
      //   .then(response => {
      //     this.transactions2 = response.data.result.data.items;
      //   }) //end success
      //   .catch(error => {
      //     console.log(error);
      //   }); //end http
    },
    showTransaction(id) {
      this.$refs.TransactionDetails1.show(id);
    },
    selected(tr) {
      this.showTransaction(tr.transaction.id);
    },
  },
  mounted() {
    this.fillTable();
    // this.$refs.tbl2.$on('selected', selected => {
    //         console.log(selected);
    //       });
  },
};
</script>
